<app-bread-crump [title]="('home.timePeriods' | translate)" [description]="('timePeriods.desc' | translate)"
  [items]="[
    { label:('Nav.Home' | translate), url: '/home' },
    { label: ('home.timePeriods' | translate) }
  ]">
</app-bread-crump>

<section class="container d-flex flex-column my-5" style="max-width: 1280px">

  @if (loading()) {
  <div class="text-center my-5">
    <span>{{ 'COMMON.loading' | translate }}</span>
  </div>
  } @else {
  <div class="global-cards-row" style="margin-block: 40px;">
    @for (period of timePeriods; track period.id) {
    <div class="global-cards-row__container">
      <div class="global-card">
        <img loading="lazy" class="community_img" [src]="period.imageUrl ? (period.imageUrl.startsWith('http') ? period.imageUrl : (environment.baseUrl + '/Files/' + period.imageUrl)) : '/media/images/custom/defualt-img.jpg'" [alt]="period.nameAR" onerror="this.src='/media/images/custom/defualt-img.jpg'" />
        <span class="card-tag" *ngIf="period.dateFrom || period.dateTo">
          {{ formatHijriYear(period.dateFrom) }} <ng-container *ngIf="period.dateFrom && period.dateTo">-</ng-container> {{ formatHijriYear(period.dateTo) }}
        </span>
        <div class="texts">
          <h3>{{ translateService.currentLang === 'en' ? period.nameEN : period.nameAR }}</h3>
          <p class="description">
            {{ translateService.currentLang === 'en' ? period.descEN : period.descAR }}
          </p>
        </div>
        <div class="buttons justify-content-start">
          <button [routerLink]="['/time-periods-quran', period.id]" class="btn-primary without-min" translate="READ_MORE"></button>
        </div>
      </div>
    </div>
    }
  </div>

  @if (timePeriods.length === 0) {
  <div class="text-center my-5">
    <p>{{ 'noItemsFound' | translate }}</p>
  </div>
  }

  @if (pagination.totalPages > 1) {
  <div class="mt-4">
    <app-browse-paginator [pagination]="pagination" (pageChange)="onPageChange($event)">
    </app-browse-paginator>
  </div>
  }
  }
</section>
